import Vue from "vue";
import Vuex from "vuex";
import * as Config from "@/store/modules/config";
import * as Common from "@/store/modules/common";
import * as Contact from "@/store/modules/contact";
import * as Instrument from "@/store/modules/instrument";
import * as Property from "@/store/modules/property";
import * as CurrentProject from "@/store/modules/CurrentProject";
import * as User from "@/store/modules/user";
import * as Search from "@/store/modules/search";
import * as Service from "@/store/modules/service";
import * as Review from "@/store/modules/review";
import EntityModule from "@/store/modules/EntityModule";
import OptionModule from "@/store/modules/OptionModule";
import { LookupModules, EntityModules } from "@/store/moduleConfig";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Common,
    Contact,
    CurrentProject,
    Instrument,
    Property,
    User,
    Search,
    Service,
    Config,
    Review,
  },
});

Object.keys(LookupModules).forEach((key) =>
  store.registerModule(LookupModules[key].namespace, OptionModule)
);
Object.keys(EntityModules).forEach((key) =>
  store.registerModule(EntityModules[key].namespace, EntityModule)
);

export default store;
